import { EventSnippet } from '../../interop/webmodule-interop';
import { TemplateResult } from 'lit';

import { WaitPatiently } from './modal-spinner';
import { LangModalSaving } from '../../../localization/webmodule-common/other/ui/modal-saving-lang';
import { lockUIandExecute } from '../ui-lock';

export async function waitPatientlySavingWithLock<T>(params: {
  action: Promise<T>;
  title?: EventSnippet;
  message?: EventSnippet;
  footerTemplate?: TemplateResult;
}) {
  const modal = new WaitPatientlySaving();
  modal.eventTitle = params.title ?? (() => LangModalSaving.saving());
  modal.message = params.message ?? (() => LangModalSaving.pleaseWait());
  modal.footer = params.footerTemplate;
  modal.delayedShow();
  return await lockUIandExecute(async () => {
    try {
      return await params.action;
    } finally {
      await modal.hideModal();
    }
  });
}

export function waitPatientlySaving(title?: EventSnippet, message?: EventSnippet, footerTemplate?: TemplateResult) {
  const modal = new WaitPatientlySaving();
  modal.eventTitle = title ?? (() => LangModalSaving.saving());
  modal.message = message ?? (() => LangModalSaving.pleaseWait());
  modal.footer = footerTemplate;
  modal.delayedShow();
  return modal;
}

//a progress window default to run will doing a save to the server

export class WaitPatientlySaving extends WaitPatiently {
  private _footer?: TemplateResult | undefined;
  public get footer(): TemplateResult | undefined {
    return this._footer;
  }

  public set footer(value: TemplateResult | undefined) {
    this._footer = value;
    this.requestUpdate();
  }

  get borderType() {
    return 'basic';
  }

  public footerTemplate(): TemplateResult | null | undefined {
    if (!this.footer) return null;
    return this.footer;
  }
}

export interface ISaveNotifier {
  done: () => Promise<void>;
}

export function saveIndicator(title?: EventSnippet, message?: EventSnippet): ISaveNotifier {
  const saving = waitPatientlySaving(title, message);
  return {
    done: async () => await saving.hideModal()
  };
}
